import React, {useContext, useMemo, useState} from "react"
import './scss/App.scss'
import {
  QueryClient,
  QueryClientProvider,
} from "react-query"
import {ReactComponent as Logo} from "./svg/logo.svg";
import {AuthCheck, GetInstanceLanguage, GetLanguageOptions, GetTranslations, GetUser} from "./API.js";
import _ from "lodash";
import Content from "./Content";
import LocaleWrapper from "./LocaleContext";


export const queryClient = new QueryClient()

const AuthContext = React.createContext({
  authContext: {},
  setAuthContext: () => {}
})

function AuthProvider({children, authContext}) {
  const [authData, setAuthData] = useState(authContext)
  const value = useMemo(() =>(
      {authData, setAuthData}
  ), [authData])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuthData() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuthData must be used within an AuthProvider')
  }
  return context
}

const CurrentUserContext = React.createContext({
  currentUserContext: {},
  setCurrentUserContext: () => {}
})

function CurrentUserProvider({children, userContext}) {
  const [currentUserData, setCurrentUserData] = useState(userContext)
  const value = useMemo(() =>(
      {currentUserData, setCurrentUserData}
  ), [currentUserData])
  return <CurrentUserContext.Provider value={value}>{children}</CurrentUserContext.Provider>
}

export function useCurrentUserData() {
  const context = useContext(CurrentUserContext)
  if (context === undefined) {
    throw new Error('useCurrentUserData must be used within an CurrentUserProvider')
  }
  return context
}

function App() {
  return <QueryClientProvider client={queryClient}>
    <Auth />
  </QueryClientProvider>
}

function Auth() {
  const authContext = window.location.hostname === "localhost" ?
      {
        status:"success",
        data:{
          "logoutURL":"https://dev.annieadvisor.com/simplesaml/module.php/core/as_logout.php?AuthId=sp-google&ReturnTo=https%3A%2F%2Fdev.annieadvisor.com%2Fapi%2Fauth.php",
          "firstname":"localhost",
          "lastname":"developer",
          "uid":"devannie",
          "status":"OK"
        }
      }
      : AuthCheck()

  const success = authContext.status === "success" && authContext.data.hasOwnProperty("uid") && authContext.data.hasOwnProperty("status") && authContext.data.status === "OK"
  const error = authContext.status === "error"

  if (success) {
    return <AuthSuccess authContext={authContext.data}/>
  }
  if (error) {
    if (typeof authContext.error.response.data.loginURL !== undefined) {
      window.location.href = authContext.error.response.data.loginURL
    } else {
      return <AuthError />
    }
  }
  return <Loading />
}

function AuthSuccess({authContext}) {
  const getUser = GetUser(authContext.uid)
  const getLanguage = GetInstanceLanguage()
  const getLanguageOptions = GetLanguageOptions()

  const error = getUser.isError || getLanguage.isError || getLanguageOptions.isError
  const success = getUser.isSuccess && getLanguage.isSuccess && getLanguageOptions.isSuccess

  if (error) {
    return <AuthError />
  }

  if (success) {
    return <AuthProvider authContext={authContext}>
      <LocaleWrapper language={getLanguage?.data[0]?.value || ""} languageOptions={getLanguageOptions?.data[0]?.value || []}>
        <UserInformation userContext={getUser.data[0]}/>
      </LocaleWrapper>
    </AuthProvider>
  }

  return <Loading />
}

function UserInformation({userContext}) {

  return <CurrentUserProvider userContext={userContext}>
    <div className={"app"}>
      <Content />
    </div>
  </CurrentUserProvider>
}

export function Loading() {
  return <div className={"app"}>
    <div className={"content center login"}>
      <div className={"loader"}>
        <Logo />
        <div className={"loader-container"}>
          <div className={"loader-bar"}/>
        </div>
      </div>
    </div>
  </div>
}

function AuthError() {
  return <div className={"app"}>
    <div className={"content center login"}>
      <div>
        <div className={"logo"}>
          <Logo />
        </div>
        <h1>Sorry. Something went wrong when authenticating. Please try again later.</h1>
      </div>
    </div>
  </div>
}

export default App;